// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/@girder/histomicsui/stylesheets/panels/annotationSelector.styl
// module id = 135
// module chunks = 0